import { cn } from '@/shared/lib/cn';

interface CampaignPhoneMockupProps {
  title?: string;
  message: string;
  channel?: string;
  className?: string;
}

/** Mockup estilo iPhone com preview da mensagem (push / SMS / WhatsApp). */
export function CampaignPhoneMockup({
  title = 'FixeCRM',
  message,
  channel = 'push',
  className,
}: CampaignPhoneMockupProps) {
  const isWhatsapp = channel === 'whatsapp';
  const channelLabel =
    channel === 'email' ? 'E-mail' : channel === 'sms' ? 'SMS' : isWhatsapp ? 'WhatsApp' : 'Push';

  return (
    <div
      className={cn(
        // Largura fixa — evita o mockup esmagar em grids/flex com espaço apertado.
        'mx-auto box-border w-[280px] min-w-[280px] max-w-[280px] shrink-0',
        className,
      )}
    >
      <div className="rounded-[2.25rem] border-[10px] border-zinc-800 bg-zinc-800 shadow-xl dark:border-zinc-700">
        <div className="relative overflow-hidden rounded-[1.6rem] bg-zinc-100 dark:bg-zinc-900">
          <div className="absolute left-1/2 top-2 z-10 h-5 w-24 -translate-x-1/2 rounded-full bg-zinc-800 dark:bg-zinc-950" />
          <div className="flex h-11 items-end justify-between px-5 pb-1 pt-3 text-[10px] font-medium text-zinc-600 dark:text-zinc-400">
            <span>9:41</span>
            <span>●●●</span>
          </div>

          {isWhatsapp ? (
            <div className="min-h-[420px] bg-[#e5ddd5] dark:bg-[#0b141a]">
              <div className="flex items-center gap-2 bg-[#075e54] px-3 py-2.5 text-white">
                <span className="grid size-8 shrink-0 place-items-center rounded-full bg-white/20 text-[11px] font-bold">
                  {(title.trim().charAt(0) || 'F').toUpperCase()}
                </span>
                <div className="min-w-0">
                  <p className="truncate text-xs font-semibold">{title}</p>
                  <p className="text-[10px] text-white/70">online</p>
                </div>
              </div>
              <div
                className="space-y-2 bg-[url('data:image/svg+xml,%3Csvg width=%2740%27 height=%2740%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M0 40L40 0H20L0 20M40 40V20L20 40%27 fill=%27%23ccc%27 fill-opacity=%270.15%27/%3E%3C/svg%3E')] p-3"
                style={{ minHeight: 360 }}
              >
                <p className="text-center text-[10px] text-zinc-500">Hoje</p>
                <div className="ml-auto max-w-[85%] rounded-lg rounded-tr-sm bg-[#dcf8c6] px-2.5 py-2 shadow-sm dark:bg-[#005c4b]">
                  <p className="whitespace-pre-wrap break-words text-xs leading-relaxed text-zinc-800 dark:text-zinc-50">
                    {message.trim() || 'Sua mensagem aparecerá aqui…'}
                  </p>
                  <p className="mt-1 text-right text-[9px] text-zinc-500 dark:text-zinc-300">9:41 ✓✓</p>
                </div>
              </div>
            </div>
          ) : (
            <div className="min-h-[420px] space-y-3 bg-gradient-to-b from-zinc-200/80 to-zinc-100 p-3 dark:from-zinc-800 dark:to-zinc-900">
              <p className="text-center text-[10px] uppercase tracking-wide text-zinc-500">{channelLabel}</p>
              <div className="rounded-2xl bg-white p-3 shadow-sm dark:bg-zinc-800">
                <div className="mb-1 flex items-center gap-2">
                  <span className="grid size-7 shrink-0 place-items-center rounded-lg bg-primary/15 text-[10px] font-bold text-primary">
                    F
                  </span>
                  <div className="min-w-0">
                    <p className="truncate text-xs font-semibold text-zinc-900 dark:text-zinc-50">{title}</p>
                    <p className="text-[10px] text-zinc-500">agora</p>
                  </div>
                </div>
                <p className="whitespace-pre-wrap break-words text-xs leading-relaxed text-zinc-700 dark:text-zinc-200">
                  {message.trim() || 'Sua mensagem aparecerá aqui…'}
                </p>
              </div>
            </div>
          )}

          <div className="flex justify-center bg-zinc-100 py-2 dark:bg-zinc-900">
            <div className="h-1 w-28 rounded-full bg-zinc-300 dark:bg-zinc-600" />
          </div>
        </div>
      </div>
    </div>
  );
}
